export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-proud-gardener-3b6441455794dd151835a1c232624556.png";